import { Flex } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
import Title from 'components/Title';

import Failed from './Failed';
import Pending from './Pending';
import Submitted from './Submitted';

const VisitsTab: React.FC<unknown> = () => {
  const { t } = useTranslation(['evv', 'common']);

  const tabHeaders = [{ label: t('common:pending') }, { label: t('common:submitted') }, { label: t('common:failed') }];
  const tabPanels = [{ panel: <Pending /> }, { panel: <Submitted /> }, { panel: <Failed /> }];

  return (
    <>
      <Flex justifyContent="space-between" flexDirection={{ base: 'column', sm: 'row' }} mb="4">
        <Title hideBackButton={true}>{t('evv:evvVisits')}</Title>
      </Flex>

      <Tabs>
        <TabHeader tabHeaders={tabHeaders} />
        <TabPanels tabPanels={tabPanels} />
      </Tabs>
    </>
  );
};

export default VisitsTab;
